import React from "react";
import {
  Box,
  Button,
  Container,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  OutlinedInput,
  Pagination,
  Paper,
  Select,
  Stack,
  TextareaAutosize,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useEffect } from "react";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import BooknowTopSection from "./BooknowTopSection";
import { Add } from "@mui/icons-material";
import { AddCircleOutline, RemoveCircleOutline } from "@mui/icons-material";

import MuiAlert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import { useContext } from "react";
import { useStore } from "../../store/useStore";
import LoginSignUpForm from "../OrderCheckOut/LoginSignUpForm";
import ServiceBookingForm from "./BookSummery/ServiceBookingForm";
import Billing from '../Billing/Billing';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
const decodeLocalData = (name) => {
  try {
    const encoded = window.localStorage.getItem(name);
    if (!encoded) return null;

    const jsonString = atob(encoded); // decode base64 to string
    return JSON.parse(jsonString);    // parse JSON string
  } catch (error) {
    console.error("Failed to decode localStorage data:", error);
    return null;
  }
};

const BookPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const navigate = useNavigate();
  const { refer, price, currency } = useParams();

  const {
    user,
    setUser,
    poster,
    portal,
    cRefer,
    ip,
  } = useStore();

  const [quantity, setQuantity] = useState(1);
  const [inputField, setInputField] = useState({});
  const [bookInfo, setBookInfo] = useState({});
  const [serviceDetails, setServiceDetails] = useState([]);

  const [getRefer, setGetRefer] = useState("");
  const [paymentInfo, setPaymentInfo] = useState({});
  const [currentCurrency, setCurrentCurrency] = useState("BDT");
  const [currentAmount, setCurrentAmount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [isLogin, setIsLogin] = useState(true);
  const [isMember, setIsMember] = useState(false);
  const [isLogged, setIsLogged] = useState(false);

  const [open2, setOpen2] = useState(false);
  const handleOpen2 = () => setOpen2(true);

  const [open, setOpen] = useState(false);

  const handleClick = () => setOpen(true);
  
  const handleClose = (_, reason) => {
    if (reason === "clickaway") return;
    setOpen(false);
  };

  const [snackMessage, setSnackMessage] = useState("");
  
       const [snackOpen, setSnackOpen] = useState(false);
    const handleSnackOpen = (message) => {
      setSnackOpen(true);
        setSnackMessage(message);
  
    };


  const handleSnackClose = (_, reason) => {
    if (reason === "clickaway") return;
    setSnackOpen(false);
  };

  const localData = decodeLocalData("gh_sl@g");
  const userParams = "book";

  useEffect(() => {
    const formData = new FormData();
    formData.append("pref", refer);
    formData.append("action", "fetch");

    fetch("https://aps.songjukti.com/profile/login/api_service/new_24/al_service_detailsNew.php", {
      method: "POST",
      body: formData,
    })
      .then((res) => res.json())
      .then((result) => setServiceDetails(result))
      .catch((error) => console.error("ServiceApiError:", error));
  }, [refer]);

  useEffect(() => {
    const isValidMember = !!(user?.refer && user?.sopnoid && user?.membership);
    const isValidLogin = !!user?.sopnoid;

    setIsMember(isValidMember);
    setIsLogged(isValidLogin);

    const storedUser = decodeLocalData("gh_sl@g");

    if (!isValidLogin && storedUser) {
      try {
        const originMatches = storedUser?.origin === window.location.origin;
        const hasValidId = !!storedUser?.sopnoid;

        if (originMatches && hasValidId) {
          setUser(storedUser);
          setIsLogged(true);
          setIsMember(!!(storedUser?.refer && storedUser?.membership));
        } else {
          localStorage.removeItem("gh_sl@g");
        }
      } catch (err) {
        console.error("Failed to parse stored user", err);
        localStorage.removeItem("gh_sl@g");
      }
    }
  }, [user]);

  return (
    <Box>
      {/* Snackbar */}
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success" sx={{ width: "100%" }}>
          This is a success message!
        </Alert>
      </Snackbar>

        <Snackbar
        open={snackOpen}
        autoHideDuration={4000}
        onClose={handleSnackClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert onClose={handleSnackClose} severity="info" sx={{ width: "100%" }}>
          {snackMessage}
        </Alert>
      </Snackbar>
      
 <Billing
        open2={open2}
        setOpen2={setOpen2}
        handleOpen2={handleOpen2}
        getRefer={getRefer}
        setGetRefer={setGetRefer}
        setPaymentInfo={setPaymentInfo}
        paymentInfo={paymentInfo}
        currentCurrency={currentCurrency}
        setCurrentCurrency={setCurrentCurrency}
        currentAmount={currentAmount}
        setCurrentAmount={setCurrentAmount}
      />
      <Container maxWidth="xl">
        <Grid container spacing={2} mt={isMobile ? 2 : 5}>
          {/* Left: Service Overview */}
          <Grid item xs={12} md={6} borderRight={{ md: "1px solid #ccc" }}>
            <Box sx={{ p: isMobile ? 2 : 3 }}>
              <BooknowTopSection serviceDetails={serviceDetails} />
            </Box>
          </Grid>

          {/* Right: Form/Login */}
          <Grid item xs={12} md={6}>
            <Box
              className="bg-white rounded-lg shadow-md"
              sx={{
                p: isMobile ? 2 : 3,
              }}
            >
              {!isLogged ? (
                <LoginSignUpForm
                  isLogin={isLogin}
                  setIsLogin={setIsLogin}
                  loading={loading}
                  setLoading={setLoading}
                  setIsSubmitting={setIsSubmitting}
                  setIsLogged={setIsLogged}
                  handleSnackOpen={handleSnackOpen}
                  handleSnackClose={handleSnackClose}
                  isLogged={isLogged}
                />
              ) : (
                <ServiceBookingForm
                  inputField={inputField}
                  setInputField={setInputField}
                  bookInfo={bookInfo}
                  setBookInfo={setBookInfo}
                  quantity={quantity}
                  setQuantity={setQuantity}
                  serviceDetails={serviceDetails}
                  user={user}
                  localData={localData}
                  navigate={navigate}
                  setGetRefer={setGetRefer}
                  setCurrentAmount={setCurrentAmount}
                  setCurrentCurrency={setCurrentCurrency}
                  setPaymentInfo={setPaymentInfo}
                  handleClick={handleClick}
                  handleOpen2={handleOpen2}
                  userParams={userParams}
                />
              )}
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default BookPage;
